// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Checkbox" (474:71). Do not edit.
//
// The "disabled" and "hover" axes are interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const checkboxContract = {
    component: 'Checkbox',
    nodeId: '474:71',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'CheckboxIndeterminate', variants: [] },
        { component: 'CheckboxSelected', variants: [] },
        { component: 'CheckboxUnselected', variants: [] },
    ],
    stateAxis: 'disabled',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: ['S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,'],
    props: {
        labelText: { kind: 'text' },
        showLabel: { kind: 'boolean' },
        status: { kind: 'enum', values: ['indeterminate', 'selected', 'unselected'] },
    },
    variants: {
        'status=indeterminate': {
            container: 'group/checkbox gap-m h-[1.375rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-content-on-primary',
            disabled: 'opacity-disabled',
            visited: '',
            box: 'bg-action-default border-action-default border-2 rounded-common w-[1.25rem] h-[1.25rem] hover:bg-action-hover hover:border-action-hover',
            parts: {
                'Rectangle 20':
                    'bg-action-default border-action-default border-2 rounded-common w-[1.25rem] h-[1.25rem] group-hover/checkbox:bg-action-hover group-hover/checkbox:border-action-hover',
                'Rectangle 28': 'bg-content-on-primary w-[0.75rem] h-[0.125rem]',
                'label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                label: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [{ component: 'CheckboxIndeterminate', variants: [] }],
        },
        'status=selected': {
            container: 'group/checkbox gap-m h-[1.375rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-content-on-primary',
            disabled: 'opacity-disabled',
            visited: '',
            box: 'bg-action-default border-action-default border-2 rounded-common w-[1.25rem] h-[1.25rem] hover:bg-action-hover hover:border-action-hover',
            parts: {
                'Rectangle 20':
                    'bg-action-default border-action-default border-2 rounded-common w-[1.25rem] h-[1.25rem] group-hover/checkbox:bg-action-hover group-hover/checkbox:border-action-hover',
                'Vector': 'w-[0.8187rem] h-[0.6133rem]',
                'label': 'text-content-default text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I7017:130998;7010:130925',
                    width: 14,
                    height: 10,
                    paths: [
                        {
                            d: 'M4.6625 9.8125L13.1 1.375L11.7625 0L4.6625 7.1375L1.325 3.775L0 5.1125L4.6625 9.8125Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                label: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [{ component: 'CheckboxSelected', variants: [] }],
        },
        'status=unselected': {
            container: 'group/checkbox gap-m h-[1.375rem] items-center',
            label: 'text-content-default text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: 'border-action-grey-action border-2 rounded-common w-[1.25rem] h-[1.25rem] hover:border-action-grey-action-hover',
            parts: {
                Rectangle:
                    'border-action-grey-action border-2 rounded-common w-[1.25rem] h-[1.25rem] group-hover/checkbox:border-action-grey-action-hover',
                label: 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                label: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [{ component: 'CheckboxUnselected', variants: [] }],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
